import Api from 'libs/api/index';

class VacancyLanguagesApi extends Api {
  constructor() {
    super('cv/vacancy_languages/');
  }
}

export default VacancyLanguagesApi;
